import styled from 'styled-components';

export const ControlSpacer = styled.div.attrs({
  tabIndex: -1,
})`
  margin-top: 1em;
`;
